import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import { environment } from 'src/environments/environment';
import {ProvaAcquisto} from "../_Models/prova-acquisto";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {ClassicType} from "../../shared/models/ClassicType";
import {ToastrService} from "ngx-toastr";
import {RmaProdottoAddComponent} from "../rma-add/rma-prodotto-add.component";
import {HttpClient, HttpEventType} from "@angular/common/http";
import {ApiRestService as sharedApiRestService} from "../../shared/_services/api-rest.service";
import {ApiRestService as AdminApiRestService} from "../../Admin/_service/api-rest.service";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ApiPathsService} from "../../api-paths.service";
import {ProdottiRmaStoreService} from "../_services/prodotti-Rma-store.service";
import {ApiRestService} from "../_services/api-rest.service";
import {RmaStoreService} from "../_services/rma-store.service";
import {DownloadService} from "../../shared/_services/download.service";
import {Permission} from "../../Login/_guards/Permission";
import {AuthenticationService} from "../../Login/_services/authentication.service";
import {Azienda} from "../../Admin/models/Azienda";
import { Progetto } from 'src/app/Progetti/Models/Progetto';
import {CampoAggiuntivo} from "../../shared/models/campo-aggiuntivo";
import { RmaData } from '../RmaData';

@Component({
  selector: 'app-edit-prova-acquisto',
  templateUrl: './edit-prova-acquisto.component.html',
  styleUrls: ['./edit-prova-acquisto.component.css']
})
export class EditProvaAcquistoComponent implements OnInit {
  dropdownSettings:IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    textField: 'label',
    idField: 'id'
  };
  Difetti: any[] = [];
  difettilist: ClassicType[] = [];
  Brand: ClassicType[] = [];
  Brands: ClassicType[] = [];
  onClose = new EventEmitter();
  provaAcquisto: ProvaAcquisto;
  Ricevuta: any = undefined;
  enableUploadBtn: boolean = true;
  uploadPercent: number;
  Acquisti: any;
  types: ClassicType[] = [];
  environment = environment;
  saveDisabled: boolean;
  Targhetta: any = undefined;
  TarghettaPrev: any;
  cliente: Azienda;
  Progetto : Progetto;
  DropdownSources: any = {
    SediSource: [],
    ProdottiSource: [],
  };
  Sede: number;

  constructor(
    private toastService: ToastrService,
    private http: HttpClient,
    private adminApiRestService: AdminApiRestService,
    private modalService: NgbActiveModal,
    private modal: NgbModal,
    private apiPaths: ApiPathsService,
    private KeyStore: ProdottiRmaStoreService,
    private RmaStore: RmaStoreService,
    private downloadService: DownloadService,
    private authsvc: AuthenticationService,
    public permission: Permission,
    private rmaData: RmaData,
  ) { }
  cancelClick() {
    this.modalService.dismiss();
    this.onClose.emit();
  }
  ngOnInit(): void {
    if(environment.RmaAddOn['CampiProvaAcquisto'] && environment.RmaAddOn['CampiProvaAcquisto'].find(x => x['source'] == 'ProdottiSource') != undefined)
      this.apiPaths.ClassicPost('/prodotti/list',{page: 0, size: 10}).subscribe(data=>{
        this.DropdownSources.ProdottiSource = data?.data ?? [];
        // this.provaAcquisto.prodottoObject = this.DropdownSources.ProdottiSource.find(x=>x.id == this.provaAcquisto.prodottoId);
      })
    this.KeyStore.getProdottiKeyTypes();
    this.RmaStore.GetTypes();
    this.KeyStore.$types.subscribe(data=> this.types = data);
    this.RmaStore.$types.subscribe(data=> this.difettilist = data);
    if(environment.RmaAddOn['CampiProvaAcquisto']?.find(x => x['source'] == 'SediSource') != undefined)
      this.adminApiRestService.getSediCliente({id: this.cliente?.id }).subscribe(data=> {
        this.DropdownSources.SediSource = data;
      })
    if(environment.RmaAddOn['CampiProvaAcquisto']?.find(x => x['OutputField'] == 'prodotto') != undefined)
     this.provaAcquisto['modelloObject'] = {prodotto: this.provaAcquisto.prodotto};

    this.provaAcquisto['dismessochk'] = this.provaAcquisto['dismesso'];

    // this.DropdownSources.SediSource = this.cliente?.sedi ?? [];
    this.provaAcquisto.sedeObject = this.Sede ? this.cliente?.sedi.find(x => x.id == this.Sede): this.provaAcquisto.sedeObject;

    this.apiPaths.ClassicGet('/rma/register/types',{ headers: this.rmaData.getRmaHeaders() },this.rmaData.getRmaLink()) //tipi acquisti
      .subscribe(data => {
        this.Brands = data;
      });
  }
  FormGetter(){
    console.log(this.authsvc?.currentUserValue)
    var formData: FormData = new FormData();
    formData.append("prodotto", this.provaAcquisto.prodotto);
    if(environment.RmaAddOn.TipoAcquisto && (this.Acquisti?.length>0 || this.types?.length>0) )
      formData.append("acquisto", (RmaProdottoAddComponent.GetClassicTypeIntFirstID(this.Acquisti?.length>0 ? this.Acquisti: this.types) ?? 0).toString())
    if(environment.RmaAddOn.Rivenditore )
      formData.append("rivenditore", this.provaAcquisto?.rivenditore && this.provaAcquisto?.rivenditore != "" ? this.provaAcquisto.rivenditore : this.authsvc?.currentUserValue?.fullName )
    if(environment.RmaAddOn.Matricola)
      formData.append("seriale", this.provaAcquisto.seriale)
    if(environment.RmaAddOn.NumeroDocumento)
      formData.append("numeroDoc", this.provaAcquisto.numeroDoc)
    if(environment.RmaAddOn.DataDocumento)
      formData.append("dataDoc", this.provaAcquisto.dataDoc)
    if(this.Ricevuta && environment.RmaAddOn.Ricevuta)
      formData.append("ricevuta", this.Ricevuta)
    if(this.Targhetta && environment.RmaAddOn.Targhetta)
      formData.append("targhetta", this.Targhetta)
    if(environment.RmaAddOn.CircostanzaDifetto && (this.provaAcquisto?.difetto || this.Difetti?.length > 0))
      formData.append("difetto", this.provaAcquisto?.difetto?.toString() ?? RmaProdottoAddComponent.GetClassicTypeIntFirstID(this.Difetti)?.toString())
    if(environment.RmaAddOn.Brand && (this.provaAcquisto?.brand || this.Brands?.length > 0))
      formData.append("brand", this.provaAcquisto?.brand?.toString() ?? RmaProdottoAddComponent.GetClassicTypeIntFirstID(this.Brands)?.toString())
    if(environment.RmaAddOn.Brand)
      formData.append("brandDesc", this.provaAcquisto.brandDesc)
    if(environment.RmaAddOn['Cliente']?.Referente)
      formData.append("acquirente[referente]", this.provaAcquisto.acquirente.referente)
    if(environment.RmaAddOn['Cliente']?.Nominativo)
      formData.append("acquirente[nominativo]", this.provaAcquisto.acquirente.nominativo)
    if(environment.RmaAddOn['Cliente']?.Indirizzo)
      formData.append("acquirente[indirizzo]", this.provaAcquisto.acquirente.indirizzo)
    if(environment.RmaAddOn['Cliente']?.Citta)
      formData.append("acquirente[citta]", this.provaAcquisto.acquirente.citta)
    if(environment.RmaAddOn['Cliente']?.Cap)
      formData.append("acquirente[cap]", this.provaAcquisto.acquirente.cap)
    if(environment.RmaAddOn['Cliente']?.Provincia)
      formData.append("acquirente[provincia]", this.provaAcquisto.acquirente.provincia)
    if(environment.RmaAddOn['Cliente']?.Telefono)
      formData.append("acquirente[telefono]", this.provaAcquisto.acquirente.telefono)
    if(environment.RmaAddOn['Cliente']?.Email)
      formData.append("acquirente[email]", this.provaAcquisto.acquirente.email)
    if(this.cliente?.id)
      formData.append("cliente", this.cliente?.id?.toString())
    if(this.Progetto?.id)
      formData.append("progetto", this.Progetto?.id?.toString())
    return formData;

  }

  Oggetto(source:any, campo: CampoAggiuntivo, oggetto:string, index: number) {
    return campo.type == 'object' ? source[oggetto][campo.field[index]] : source[oggetto];
  }

  DynamicFormGetter(campi, source: ProvaAcquisto){
    console.log("Prova Acquisto",source)
    const _form: FormData = ApiPathsService.DynamicFormGetter(campi,source);
    if(this.cliente?.id)
      _form.append("cliente", this.cliente?.id?.toString())
    if(this.Progetto?.id)
      _form.append("progetto", this.Progetto?.id?.toString())
    if(environment.RmaAddOn.Targhetta && this.provaAcquisto.targhetta)
      _form.append("targhetta", this.provaAcquisto.targhetta)
    if(environment.RmaAddOn.Ricevuta && this.provaAcquisto.ricevuta)
      _form.append("ricevuta", this.provaAcquisto.ricevuta)
    if(environment.RmaAddOn.Rivenditore && !this.provaAcquisto?.rivenditore )
      _form.append("rivenditore",  this.authsvc?.currentUserValue?.fullName )

    return _form;
  }
  // OnChangeHandler(event: {OnFilter: string, Event: string}){
  //   switch (event.OnFilter){
  //     case "filtroManager":
  //       this.filtroManager(event.Event);
  //       break;
  //   }
  // }

  Save() {
    this.saveDisabled = true;
    if(environment.RmaAddOn['defaultBrand']){
      this.provaAcquisto.brand = environment.RmaAddOn['defaultBrand']?.brand;
      this.provaAcquisto.brandDesc = environment.RmaAddOn['defaultBrand']?.brandDesc;
      this.provaAcquisto.difetto = environment.RmaAddOn['defaultBrand']?.difetto;
    }
    const _data = environment.RmaAddOn['CampiProvaAcquisto']
      ? this.DynamicFormGetter(environment.RmaAddOn['CampiProvaAcquisto'], this.provaAcquisto)
      : this.FormGetter();
    if (!this.provaAcquisto?.id) { // Add
      this.send(_data, "/rma/register/add");
    } else {
      const headers = this.rmaData.getRmaHeaders();
      const link = this.rmaData.getRmaLink();
      this.apiPaths.ClassicPost("/rma/register/update", this.provaAcquisto, { headers }, link)
        .subscribe(
          () => this.cancelClick(),
          error => this.handleErrors(error)
        );
    }
  }
  Duplica(){
    this.Save();
    this.modalService.dismiss();
    const editmodal = this.modal.open(EditProvaAcquistoComponent,{
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<EditProvaAcquistoComponent>editmodal.componentInstance).provaAcquisto = new ProvaAcquisto(this.provaAcquisto.acquirente);
    (<EditProvaAcquistoComponent>editmodal.componentInstance).Ricevuta = this.Ricevuta;
    (<EditProvaAcquistoComponent>editmodal.componentInstance).Targhetta = this.Targhetta;
    (<EditProvaAcquistoComponent>editmodal.componentInstance).Brand = this.Brand;
    (<EditProvaAcquistoComponent>editmodal.componentInstance).Acquisti = this.Acquisti;
    (<EditProvaAcquistoComponent>editmodal.componentInstance).Difetti = this.Difetti;
    (<EditProvaAcquistoComponent>editmodal.componentInstance).cliente = !this.permission.isOperativeRoles(['C', 'AC', 'CA', 'AG'])? this.provaAcquisto.acquirente : null;
    (<EditProvaAcquistoComponent>editmodal.componentInstance).onClose.subscribe(data => {
      this.onClose.emit();
    })
  }
  async OnRicevutaFileChange(event) {
    if (!event.target.files[0].type.includes("image") && !event.target.files[0].type.includes("pdf")){
      this.toastService.warning("Questo formato non è supportato. Inserire solo immagini o PDF.", "Attenzione!")
      return;
    }
    this.Ricevuta = event.target.files[0];
  }
  async OnTarghettaFileChange(event) {
    if (!event.target.files[0].type.includes("image") && !event.target.files[0].type.includes("pdf")){
      this.toastService.warning("Questo formato non è supportato. Inserire solo immagini o PDF.", "Attenzione!")
      return;
    }
    this.Targhetta = event.target.files[0];
    //this.TarghettaPrev = await this.imgdecode(event.target.files[0]);
    await this.imgdecode(event.target.files[0]);
    console.log(this.TarghettaPrev);
  }

  async imgdecode(file: Blob){
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // console.log(reader?.result?.toString()?.length > 1 ? reader.result.toString(): undefined);
      // return reader?.result?.toString()?.length > 1 ? reader.result.toString(): undefined;
      if (reader.result.toString().length > 1){
        this.TarghettaPrev = reader.result.toString();
      }
      else
        this.TarghettaPrev = undefined;
    };
  }

  download(id: number) {
    this.apiPaths.ClassicGet(`/file/download/${id.toString()}`,{ headers: this.rmaData.getRmaHeaders(),observe:'response',responseType:'blob'}, this.rmaData.getRmaLink()).subscribe(data => {
      this.downloadService.downloadFile(data)
    });
  }

  send(formdata: FormData, restroute, headers = this.rmaData.getRmaMultipartHeaders()){
    this.http.request('POST', (this.rmaData.getRmaLink() ?? this.apiPaths.getBaseAPI()) + restroute, {
      body: formdata,
      reportProgress: true,
      observe: 'events',
      headers: headers,
      params: null,
    })
      .subscribe(
        (event) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.enableUploadBtn = false; // button should be disabled if process uploading
            // const currentDone = event.loaded / event.total;
            this.uploadPercent = Math.round((event.loaded / event.total) * 100);
          } else if (event.type === HttpEventType.Response) {
            if (event.status === 200 || event.status === 201) {
              this.cancelClick();
            }
            else
              this.handleErrors(event);
          } else {
          }
        },
        (error) => {
          this.handleErrors(error);
        }
      );
  }

  handleErrors(err?) {
    this.enableUploadBtn = true;
    console.log(err)
    if(err){
      let errorMessage = err.error.message || err.statusText;
      if (err.status === 422) {
        errorMessage = "";
        for (const field in err.error) {
          errorMessage += field + " : " + err.error[field] + '\n';
        }
      }
      this.toastService.error(errorMessage, "OOPS!!");
    }
  }


  imgurl(id){
    return !isNaN(id)? `${this.apiPaths.getBaseAPI()}/file/image/${id.toString()}`: undefined;
  }
  ChangeHandler(item: { OnChange: string; Event: any }) {
    switch (item.OnChange ){
      case 'OnFilesChange' :
        this.apiPaths.ClassicPost('/rma/register/get', {id: this.provaAcquisto.id}).subscribe(data=>{
          this.provaAcquisto = data.data;
          this.ngOnInit();
        })
        break;
    }


  }
}
